export const authControl = {
  tditAccuss: 'tditAccuss',
  lang: 'tditPungLang',
  userDate: 'userDate',
  imagevalidatation: 'imagevalidation'
};

export const listApiData = {
  pageNo: 'pageNo',
  pageNumber: 'pageNumber',
  catId: 'catId',
  pageSize: 'pageSize',
  searchText: 'searchText',
  fromDate: 'fromDate',
  toDate: 'toDate',
  name: 'name',
  deviceId: 'deviceId',
  projectId: 'projectId',
  shifId: 'shiftId',
  gateId: "gateId",
  companyName: "companyName",
  companyId: "companyId",
  projectCode: "projectCode",
  sortKey: "sortKey",
  sortType: "sortType",
  printStatus: "printStatus",
  jobId: "jobId",
  roleId: "Roleid",
  currentDate: "currentDate",
  dateTime: "dateTime",
  empType: "employeeType",
  status: "status",
  pagetype:"pageType",
  GateStatus:"GateStatus",
  ShiftStatus:"ShiftStatus",
  punchStatus:"punchStatus",
  jobName:"jobName",
  projectNumber:"projectNumber",
  reportDate:"reportDate",
  EmpId:"EmpId",
  applyDate: "applyDate",
  employeeStatus: "employeeStatus"
};

export const pageControl = {
  pageCreate: 'create',
  pageUpdate: 'Update',
  pageView: 'view',
};

export const userControl = {
  user64Img: 'user64Img',
};

export const timeKeeperPages = [
  'user-management',
  'project-assignnent',
  'punch-in-and-punch-out',
];
export const resourcePlannerPages = [
  'punch-in-and-punch-out',
  'shift-assignnent',
];
export const adminPages = [
  'user-management',
  'attendance',
  'punch-in-and-punch-out',
  'shift-assignnent',
  'project-assignnent',
  'calender',
  'role-management',
];

export const roleLists = {
  timeKeeper: 'Project Admin',
  administrator: 'Administrator',
  hrSpecialist: 'HR Specialist',
  hrAdmin: 'TD-HRMS Admin',
  hrProjectAdmin: "HQ Admin",
  CampBoss: 'Project Admin',
  hrfinance:'HR Finance'

};

export const Status = ["Active", "Inactive"];
// export const 
